<template>
  <nav class="navbar navbar-expand-lg navbar-dark" :class="gdqmodeclass">
    <div class="container-fluid">
      <router-link to="/" class="navbar-brand">
        <h1 class="mb-0 d-inline">
          <Logo />
        </h1>
      </router-link>
      
      <button 
        class="navbar-toggler" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#navbarNav" 
        aria-controls="navbarNav" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li v-if="$store.state.user_id==1" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Developer
            </a>
            <ul class="dropdown-menu">

            </ul>
          </li>
          
          <li v-if="!eventsadmin" class="nav-item">
            <router-link to="/learninghub" class="nav-link">Learning Hub</router-link>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Events
            </a>
            <ul class="dropdown-menu">
              <li><router-link to="/events" class="dropdown-item">Events</router-link></li>
              <li v-if="!eventsadmin"><router-link to="/bookings" class="dropdown-item">Event Bookings</router-link></li>
              <li v-if="!eventsadmin"><router-link to="/eventmails" class="dropdown-item">Event mails</router-link></li>
            </ul>
          </li>

          <li v-if="!eventsadmin" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Admin
            </a>
            <ul class="dropdown-menu">
              <li><router-link to="/logintext" class="dropdown-item">Login screen text</router-link></li>
              <li><router-link to="/systemmessages" class="dropdown-item">System messages</router-link></li>
              <li><router-link to="/consultants" class="dropdown-item">Consultants</router-link></li>
              <li><router-link to="/consultantgroups" class="dropdown-item">Consultant Groups</router-link></li>
              <li><router-link to="/invoicereport" class="dropdown-item">Invoices</router-link></li>
              <!-- <li><router-link to="/companies" class="dropdown-item">Companies</router-link></li> -->
              <!-- <li><router-link to="/partners" class="dropdown-item">Partners</router-link></li> -->
              <li><router-link to="/faq" class="dropdown-item">FAQ</router-link></li>
              <li><router-link to="/faqcategories" class="dropdown-item">FAQ Categories</router-link></li>
              <li><router-link to="/consentresearch" class="dropdown-item">Consent to Research</router-link></li>
              <li><router-link to="/consent" class="dropdown-item">Consent to Personal Information</router-link></li>
              <li><router-link to="/utilities" class="dropdown-item">Utilities</router-link></li>
              <li><router-link to="/screens" class="dropdown-item">Screens</router-link></li>
              <li><router-link to="/screenelements" class="dropdown-item">Screen elements</router-link></li>
              <li><router-link to="/normvaluesexport" class="dropdown-item">Export for normvalues</router-link></li>
            </ul>
          </li>
          
          <li v-if="!eventsadmin" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Settings
            </a>
            <ul class="dropdown-menu">
              <li><router-link to="/mailsettings" class="dropdown-item">Mail Settings</router-link></li>
              <li><router-link to="/gdqsettings" class="dropdown-item">GDQ Settings</router-link></li>
              <li><router-link to="/gdqshortsettings" class="dropdown-item">GDQ Short Settings</router-link></li>
              <li><router-link to="/oscsettings" class="dropdown-item">OSC Settings</router-link></li>
              <li><router-link to="/aggregatedreportsettings" class="dropdown-item">Aggregated Reports Settings</router-link></li>
              <li><router-link to="/countries" class="dropdown-item">Countries</router-link></li>
              <li><router-link to="/languages" class="dropdown-item">Languages</router-link></li>
              <li><router-link to="/labels" class="dropdown-item">Labels</router-link></li>
              <!-- <li><router-link to="/supportissues" class="dropdown-item">Support issues list</router-link></li> -->
            </ul>
          </li>
          
          <li class="nav-item">
            <a class="nav-link" href="#" @click.prevent="logout">Log out</a>
          </li>
        </ul>
        
        <div class="form-check text-white ms-3">
          <input 
            class="form-check-input" 
            type="checkbox" 
            id="anonCheck"
            v-model="anon"
            @change="toggleanon"
          >
          <label class="form-check-label text-white" for="anonCheck">
            Anon.
          </label>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
/* eslint-disable no-console */
import { config } from '../../config'
import Logo from './Logo.vue';

export default {
  name: 'Navbar',
  components: {
    Logo
  },
  data() {
    return {
      gdqmodeclass: (config.mode == 'live') ? 'bg-primary' : config.mode == 'stage' ? 'bg-secondary' : 'bg-danger',
    }
  },
  computed: {
    eventsadmin: {
      get() {
        return this.$store.state.events_admin_only === 1;
      }
    },
    anon: {
      get() {
        return this.$store.state.anon;
      },
      // eslint-disable-next-line no-unused-vars
      set(value) {
        // The setter is needed for v-model to work
        // The actual toggle is handled by toggleanon method
      }
    }
  },
  methods: {
    toggleanon() {
      this.$store.dispatch('toggleanon')
    },
    logout() {
      this.$store
        .dispatch("logout",{})
        .then(() => this.$router.push("/login"))
        .catch(err => console.log(err));
    }
  }
}
</script>

<style scoped>
.navbar-brand h1 {
  font-size: 1.25rem;
  display: inline;
}

.nav-link {
  color: rgba(255, 255, 255, 0.95) !important;
}

.nav-link:hover {
  color: rgba(255, 255, 255, 1) !important;
}

.dropdown-item:hover {
  background-color: #e9ecef;
}

.dropdown-item:active {
  background-color: #0d6efd;
}
</style>
